import restClient from '@/services/clients/rest'
import { createRestCrudService } from '@/services/GenericCrudService'

const resourceName = 'Job Phase'
const resourcePath = 'costing/jobphases'
const crudService = createRestCrudService(resourceName, resourcePath)

export default Object.assign(crudService, {
  async bulkImport (items, options) {
    try {
      const response = await restClient.post(`${resourcePath}/bulk-import`, {
        items,
        options
      })
      return response.data
    } catch (error) {
      console.warn(`Error submitting job phase bulk import`, error, items, options)
      throw error
    }
  }
})
